import React, { useEffect } from 'react';
import s from './Banner.module.css';
import Button from '../../../shared/ui/button/Button';
import BackgroundShadow from '../shared/BackgroundShadow';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const Banner: React.FC = () => {
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);
    return (
        <div className={s.container}>
            <BackgroundShadow />
            <OptimizedMotionH1 className={s.title} type="slide-down" delay={0.5}>
                Brand Analytics
            </OptimizedMotionH1>
            <OptimizedMotionP className={s.description} type="slide-down" delay={0.5}>
                Deep insights into how your brand is perceived, performs, and evolves across
                channels—helping you make smarter, data-driven decisions.
            </OptimizedMotionP>
        </div>
    );
};

export default Banner;
